module.exports = __webpack_public_path__ + "img/BIT_white27.ef7add0b.jpg";